<script>
  import { hasAccess, password } from "../store.js";
  import { getContext } from "svelte";

  const { close } = getContext("password-modal");

  let pass = "";
  let showHint = false;

  async function validPassword(pw) {
    if (pw === "null" || pw === null) return false;
    
    let url = window.location.pathname
    let validPasswords = await fetch(url.substring(0, url.lastIndexOf('/')) + "/passwords.json", {
      mode: "cors",
      headers: { "Content-Type": "application/json" },
    }).then((res) => res.json());

    const getDate = () => {
      let d = new Date();
      return d.toLocaleDateString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    };

    let d = getDate();
    if (validPasswords[d]) {
      // day exists
      let pws = validPasswords[d];
      return pws.includes(pw);
    } else {
      return false;
    }
  }

  async function click() {
    let valid = await validPassword(pass);
    $hasAccess = valid;

    if (valid) {
      $password = pass;
      close();
    } else {
      showHint = true;
      pass = "";
    }
  }

  $: inputInvalid = pass.length <= 0;
</script>

<div>
  <h3>Passwort eingeben</h3>
  <input bind:value={pass} class="pw-box" />
  <button disabled={inputInvalid} on:click={click}>Abschicken</button>
  {#if showHint}<p class="hint">Das Passwort war nicht korrekt.</p>{/if}
</div>

<style>
  div {
    text-align: center;
  }
</style>
